export default "__VITE_ASSET__b5nf8$AX__"